import { ActiveStatusBadge, InactiveStatusBadge } from "../styles/UsersStyles";

export const menuItems = [
    { id: "dashboard", label: "Dashboard", icon: "📊", to: "/dashboard" },
    { id: "users", label: "Users", icon: "👥", to: "/users" },
    { id: "category", label: "Category", icon: "📚", to: "/category" },
    { id: "products", label: "Products", icon: "📦", to: "/products" },
    { id: "HomeApps", label: "HomeApps", icon: "🧩", to: "/home" },
    { id: "orders", label: "Orders", icon: "🛒", to: "/orders" }, 
    { id: "brands", label: "Brands", icon: "🏷️", to: "/brands" }, 
    { id: "analytics", label: "Analytics", icon: "📈", to: "/analytics" },
    // { id: "settings", label: "Settings", icon: "⚙️", to: "/settings" },
    { id: "access", label: "Access", icon: "🗝️", to: "/access" },
    { id: "vendor", label: "Vendor", icon: "🏬", to: "/vendor" },
    { id: "banners", label: "Banners", icon: "🌠", to: "/banners" },
    { id: "coupons", label: "Coupons", icon: "🎟️", to: "/coupons" },
    { id: "operation", label: "Operation", icon: "💾", to: "/operation" },
  ];

  export const options = ["Dashboard", "Users", "Products", "Orders", "Analytics", "Settings", "Access", "Vendor" ,"Operation","Banners","Coupons","Home Apps","brands"];

    export const getHSNDetails = async (hsnCode) => {
      const response = await fetch(
        `https://hsn.krakelabsindia.com/api/lookup?code=${hsnCode}`
      );

      const data = await response.json();
      const result = data.results?.[0];

      if (!result) return null;

      return {
        description: result?.description || '',
        gstRate: result?.gst_rate ? Number.parseFloat(result.gst_rate) : null,
        hsnCode: result?.hsn_sac || hsnCode
      };
    };

    export const getStatusBadge = (status) => {
      if(status == true){
        return <ActiveStatusBadge>Yes</ActiveStatusBadge>;
      }else{
        return <InactiveStatusBadge>No</InactiveStatusBadge>;
      }
    };
